import React from "react";
import { ClipboardList, CalendarClock, PenTool, LineChart } from "lucide-react";

const items = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Strategy & Audit",
    desc: "We’ll review the challenges and successes you’ve experienced to date with your list, identify issues, and suggest recommendations for resolving them. No list yet? Don’t worry—we can help you set yours up right from the start, so sending issues won’t plague you down the road. We’ll also suggest ways to grow and activate your list through complementary marketing channels.",
    accent: "var(--bpm-orange)",
  },
  {
    n: "02",
    icon: CalendarClock,
    title: "Calendar & Automations",
    desc: "Let’s find the right cadence for your email marketing, one that connects with customers without burying them in a blizzard of ineffective messages. Thoughtfully deployed automations will be part of the mix, arranged to welcome and remind subscribers, never to hassle them.",
    accent: "var(--bpm-teal)",
  },
  {
    n: "03",
    icon: PenTool,
    title: "Design & Content",
    desc: "Working with your existing email marketing, brand identity, and list, we’ll craft templates that resonate with your customers, adjusting to feedback as we go. We’ll create clear, accessible copy with defined calls-to-action (CTA) to drive clicks. Design proofing will ensure your emails look great no matter what platform or device they’re opened on.",
    accent: "var(--bpm-mustard)",
  },
  {
    n: "04",
    icon: LineChart,
    title: "Analysis",
    desc: "As we build your email marketing presence, we’ll engage in continual review of your key performance indicators (KPIs) such as open rates, click-through rates (CTR), and bounce rates. List hygiene will be implemented and we’ll handle reputation and authentication-based deliverability issues, including compliance with DMARC, DKIM, SPF, and CAN-SPAM rules.",
    accent: "var(--bpm-coral)",
  },
];

export const Services = () => {
  return (
    <section id="services" className="section-divider radio-waves relative" style={{ "--rw-x": "100%", "--rw-y": "50%" }} data-testid="services-section">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-8">
          <div className="lg:col-span-12">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-5">
              Our Process
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-testid="services-grid">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <article
                key={it.n}
                className="callout group fade-up p-7 md:p-9"
                style={{ animationDelay: `${i * 60}ms` }}
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-center justify-between mb-4">
                  <div
                    className="w-11 h-11 rounded-full flex items-center justify-center"
                    style={{ background: it.accent + "1F", border: `1px solid ${it.accent}` }}
                  >
                    <Icon size={18} style={{ color: it.accent }} />
                  </div>
                </div>
                <h3 className="font-display text-2xl md:text-3xl" style={{ color: "var(--bpm-cream)" }}>
                  {it.title}
                </h3>
                <p className="mt-4 text-[14.5px] leading-[1.7] text-[color:var(--bpm-cream-soft)]">
                  {it.desc}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
